import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';
import { useState } from 'react';

export default function BetaBanner() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="relative bg-[#d8b34a] text-black">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-2.5 flex items-center justify-center gap-3 text-center">
        <Sparkles size={14} strokeWidth={2.2} className="hidden sm:block" />
        <p className="text-[12px] sm:text-sm font-semibold">
          Beta launch is here —
          <Link to="/signup" className="underline ml-1 hover:no-underline">sign up now for free access</Link>.
          <span className="hidden md:inline font-normal opacity-80"> Paper trading only · no live funds during beta.</span>
        </p>
        <button
          aria-label="Dismiss banner"
          onClick={() => setOpen(false)}
          className="absolute right-3 top-1/2 -translate-y-1/2 hover:opacity-70"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
